import store from '../store/index'

function scanCode() {

	let str = ''
	document.onkeydown = function() {
		// console.log('event',event);
		if (event.target.baseURI.indexOf('wmswmsGoodsIn') == -1) {
			str = ''
		} else {
			if (event.keyCode === 14) {
				str = '';
			} else {
				if (event.keyCode !== 13) {
					let k = event.key
					str += k
					console.log(str);
					//    if (event.keyCode >= 32 && event.keyCode <= 126) {
					//      let k = event.key
					//      str += k
					// console.log(str);
					//    }
				} else {
					if (str) {
						// console.log(str);
						store.commit('scanCode/SET_SCANSTRING', str)
						// console.log(store);
					}
					str = ''
				}
			}
		}
	}
}

export default scanCode()


// WEBPACK FOOTER //
// ./src/utils/scanCode.js